import { useState } from "react";
import { useFormikContext } from "formik";

export const useFormValidation = (onContinue: () => void) => {
  const [isValidating, setIsValidating] = useState(false);
  const { validateForm } = useFormikContext();

  const handleContinueClick = async () => {
    setIsValidating(true);
    const errors = await validateForm();

    if (Object.keys(errors).length === 0) {
      onContinue();
    } else {
      console.log("Validation errors:", errors);
    }

    setIsValidating(false);
  };

  return {
    isValidating,
    handleContinueClick,
  };
};
